module.exports = __webpack_public_path__ + "img/avataaars-circle.4213e0d5.svg";